import React from 'react'
import axios from 'axios'
import bbcode, { Tag } from 'bbcode-to-react'
import './BBTags'

class BBContent extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      content: null
    }
  }

  componentDidMount() {
    this.loadContent(this.props.path)
  }

  componentWillReceiveProps(props) {
    this.loadContent(props.path)
  }

  loadContent(path) {
    if (path) {
      axios.get(path).then(res => {
        try {
          this.setState({
            content: res.data && bbcode.toReact(res.data)
          })
        }
        catch (e) {
          console.error(e)
        }
      })
    }
  }

  render() {
    if (this.props.content) {
      return bbcode.toReact(this.props.content)
    }
    return this.props.content || this.state.content || null
  }

}

export default BBContent